import React, { useState } from 'react';
import Select from 'react-select';
import useLanguaje from '../hooks/useLanguaje';
import openArrow from '../themed/images/open-lenguaje.svg';
import closeArrow from '../themed/images/close-lenguaje.svg';

const LanguageSelector = props => {
  const [prefix] = useState(props?.prefix ? props?.prefix : 'select');

  const { langauges, updateUser, selectRef, valueLang } = useLanguaje();

  return (
    <Select
      id={prefix}
      classNamePrefix={prefix}
      value={
        valueLang?.value === 'es' ? { value: 'es', label: 'ES' } : { value: 'en', label: 'EN' }
      }
      options={langauges}
      onChange={updateUser}
      closeMenuOnScroll={false}
      isSearchable={false}
      ref={selectRef}
      menuPlacement="top"
      theme={theme => {
        return {
          ...theme,
          colors: {
            ...theme.colors,
            primary25: '#36B9D00D',
            primary: '#36b9d0',
            primary50: '#36b9d0'
          }
        };
      }}
      components={{
        DropdownIndicator: props => {
          return (
            <img
              className="p-r-8 dropdown-language-selector"
              src={props.selectProps.menuIsOpen ? closeArrow : openArrow}
            />
          );
        },
        IndicatorSeparator: () => null
      }}
      className="font-xs language-selector"
    ></Select>
  );
};

export default LanguageSelector;
